import { TableColumn } from '../../../../component-library/table/table-column';
import { TableConfig } from '../../../../component-library/table/table-config';
import { Widget } from '../../../../viewmodels/dashboard/widget';
import { WidgetParameter } from '../../../../viewmodels/dashboard/widget-parameter';
import { MitigationItemizedWidgetData } from './mitigation-itemized-widget-data';

export class OverdueMitigationItemizedWidgetData extends MitigationItemizedWidgetData {
  public createTableConfig(): TableConfig {
    const tableConfig = super.initializeTableConfig();
    tableConfig.columns = this.createColumns();
    return tableConfig;
  }

  public setFilterParameter(widget: Widget, widgetParam: WidgetParameter, reset: boolean) {
    this.setMitigationFilterParameter(widget, widgetParam, reset);
  }

  protected createColumns(): TableColumn[] {
    return this.createMitigationColumns(true);
  }

  public createOverallTableHeaderColumn(): TableColumn {
    return this.createMitigationOverallTableHeaderColumn(true);
  }
}
